const it = require('./it.json')
const en = require('./en.json')

module.exports = {
  it,
  en,
}
